import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ApiConectateService } from '../../api/apiConectate';
import { ApiTokboxService } from '../../api/apiTokbox';
import { Room, RoomSchedule } from '../../models';
import { HeaderService } from '../../services/header/header.service';
import { DisconnectedComponent } from './components/disconnected/disconnected.component';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { StateHandlerService } from '../../services/state-handler/state-handler.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { UtilsService } from '../../services/utils/utils.service';
import { VIDEOCONFERENCE_CONSTANTS } from '../../constants/videoconference.constants';
import { ROUTES_CONSTANTS } from '../../constants/routes.constants';
import { SurveyComponent } from './components/survey/survey.component';
import { JsonPipe } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  standalone: true,
  imports: [DisconnectedComponent, SurveyComponent],
  selector: 'sas-room',
  templateUrl: './room.component.html',
  styleUrls: ['./room.component.scss'],
})
export class RoomComponent implements OnInit, OnDestroy {
  public invalidPassword?: boolean;
  public disconnected?: string;
  public roomData?: Room;
  public roomSchedule?: RoomSchedule;
  public publisher?: OT.Publisher;
  public showSurvey: boolean = false;
  /**
   * Subject para el unsubscribe de los observables al destriur el componente.
   */
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private goToken?: string;
  private accessPin?: string;
  public forcePublisherOff = false;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly headerSvc: HeaderService,
    private readonly sessionStorageSrv: SessionStorageService,
    private readonly stateHandlerSrv: StateHandlerService,
    private readonly enviroment: EnvironmentService,
    private readonly router: Router,
    private readonly apiTokBoxSvc: ApiTokboxService,
    private readonly apiConectateServ: ApiConectateService,
    private readonly utilsService: UtilsService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    console.log(
      'ENTRANDO EN LA SALA DE ESPERA ------------------------------>'
    );
    if(environment.isPatient){
      this.showSurvey = this.stateHandlerSrv.getWithoutObs('goToSurvey');
    }
    const prevStatusConnection = this.sessionStorageSrv.get('statusConnection');
    this.headerSvc.setStateConection(false);
    this.stateHandlerSrv.get('disconnected_status').subscribe((status) => {
      console.log(
        "room stateHandlerSrv.get('disconnected_status') (" +
          this.utilsService.getTodayWithHour() +
          ') status:',
        status
      );
      if (status && status !== '') {
        this.disconnected = status;
      } else {
        if(environment.isPatient){
          var urlPin = this.sessionStorageSrv.get('s');
          this.sessionStorageSrv.clear();
          this.sessionStorageSrv.set('s', urlPin)
        }else{
          this.sessionStorageSrv.clear();
        }
        
      }

      prevStatusConnection
        ? (this.disconnected = 'hung_up')
        : this.activatedRoute.queryParams
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((params) => {
              if (params['go']) {
                this.goToken = params['go'];
                this.disconnected = 'start';
              } else {
                // Auth methods
                this.accessPin = params['pin'] ? params['pin'] : '';

                if (this.disconnected !== 'hung_up') {
                  this.accessRoom(
                    params[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT],
                    this.accessPin
                  );
                }
              }
              this.cdr.detectChanges();
            });

      this.subscribeToSurvey();
    });
  }

  enterName(name: string) {
    const dataToSend = {
      id: this.goToken,
      name: name,
      email: 'demo.gofit@experis.es',
    };
    this.apiConectateServ.createInvitation(dataToSend).subscribe((res) => {
      console.log(
        'room enterName createInvitationt() (' +
          this.utilsService.getTodayWithHour() +
          ') res:',
        res
      );
      this.accessRoom(res.id, res.pin);
    });
  }

  sendPassword(pin?: string) {
    const attendantId =
      this.activatedRoute.snapshot.queryParams[
        VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT
      ];

    if (this.enviroment.data?.features?.pin_required) {
      this.apiConectateServ.getAuthentication(attendantId, pin).subscribe(
        () => {
          console.log(
            'room enterName sendPassword subscribe success (' +
              this.utilsService.getTodayWithHour() +
              ')'
          );
          this.accessRoom(attendantId, pin);
        },
        (err: any) => {
          this.handleRoomError(err);
          this.invalidPassword = true;
        }
      );
    } else {
      this.accessRoom(attendantId, pin);
    }
  }

  /**
   * Método que recibe del disconected el publisher usaro en la
   * sala de espera para el widget de audio/video.
   *
   * @param {OT.Publisher} [publisher]
   */
  setWaitingtRoomPublisher(publisher: OT.Publisher) {
    console.log(
      'room setWaitingtRoomPublisher (' +
        this.utilsService.getTodayWithHour() +
        ') publisher:',
      publisher
    );
    this.publisher = publisher;
  }

  entryAgain(data: any) {
    if (data) {
      this.stateHandlerSrv.get('roomData').pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: Room) => {
        this.roomData = response;
        const attendantId =
        this.activatedRoute.snapshot.queryParams[
          VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT
        ];
        const pin =
          this.activatedRoute.snapshot.queryParams[
            VIDEOCONFERENCE_CONSTANTS.URL_PARAM_PIN
          ];
        const doPolling =
          this.roomData?.roleType === this.enviroment.data?.polling?.roleType &&
          this.enviroment.data?.features?.wait_for_amphitryon;

        // tslint:disable:no-unused-expression
        doPolling
          ? this.getDoctorStatePolling(attendantId, pin)
          : this.navigateToVideoconference(attendantId, pin);
        this.cdr.detectChanges();
      });
      
    }
  }

  private accessRoom(attendantId: string, pin?: string) {
    this.apiConectateServ
      .accessRoom(attendantId, pin)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (room: Room) => {
          console.log(
            'room apiConectateServ.accessRoom( (' +
              this.utilsService.getTodayWithHour() +
              ') room:',
            room
          );
          this.headerSvc.setStateConection(true);
          this.roomData = room;
          this.apiTokBoxSvc.roomData = this.roomData;
          this.stateHandlerSrv.set('roomData', this.roomData);
          this.stateHandlerSrv.set('activeSurvey', room.activeSurvey);
          const doPolling =
            this.roomData.roleType ===
              this.enviroment.data?.polling?.roleType &&
            this.enviroment.data?.features?.wait_for_amphitryon;

          // tslint:disable:no-unused-expression
          doPolling
            ? this.getDoctorStatePolling(attendantId, pin)
            : this.navigateToVideoconference(attendantId, pin);
        },
        error: (err:any) => this.handleRoomError(err),
      });
  }

  private navigateToVideoconference(attendantId: string, pin?: string) {
    this.stateHandlerSrv.set(
      'cameraButtonState',
      typeof this.sessionStorageSrv.get('cameraButtonState') === 'boolean'
        ? this.sessionStorageSrv.get('cameraButtonState')
        : true
    );
    this.stateHandlerSrv.set(
      'microButtonState',
      typeof this.sessionStorageSrv.get('microButtonState') === 'boolean'
        ? this.sessionStorageSrv.get('microButtonState')
        : true
    );
    this.forcePublisherOff = true;
    const queryParams =
      this.enviroment.data?.features?.pin_required && pin
        ? { access: attendantId, pin }
        : { access: attendantId };
    const navigationExtras: NavigationExtras = {
      queryParams: queryParams,
      replaceUrl: true,
    };
    console.log(
      'room navigateToVideoconference publisher.off() (' +
        this.utilsService.getTodayWithHour() +
        ')'
    );
    this.publisher?.off();
    console.log(
      'room navigateToVideoconference publisher.destroy() (' +
        this.utilsService.getTodayWithHour() +
        ')'
    );
    this.publisher?.destroy();
    this.router.navigate(
      [ROUTES_CONSTANTS.VIDEOCONFERENCE.path],
      navigationExtras
    );
  }

  private getDoctorStatePolling(
    attendantId: string,
    pin?: string,
    token?: string
  ) {
    let isSendPatientConnectedNotification: boolean;
    this.headerSvc.setStateConection(true);
    this.disconnected = VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.WAITING;
    const intervalId = setInterval(() => {
      this.apiConectateServ.getUserState(attendantId).subscribe((state) => {
        console.log(
          'room apiConectateServ.getUserState (' +
            this.utilsService.getTodayWithHour() +
            ') state:',
          state
        );
        if (state && state.activated) {
          clearInterval(intervalId);
          this.navigateToVideoconference(attendantId, pin);
        }else if(!isSendPatientConnectedNotification && environment.isPatient) {          
          this.apiConectateServ.sedPatientConnectedNotification().subscribe(
            res => {
              console.log('Post al servicio de envío de correo');
              isSendPatientConnectedNotification = true;
               this.cdr.detectChanges();
            }
          );
        }
        this.cdr.detectChanges();
      });
    }, this.enviroment.data?.polling?.intervalDuration);
  }

  private subscribeToSurvey() {
    this.stateHandlerSrv
      .get('goToSurvey')
      .subscribe((res) => (this.showSurvey = res));
  }

  private handleRoomError(err: any) {
    const errMap: any = {
      404: VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.NOT_FOUND,
      401: VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.PASSWORD_REQUIRED,
      410: VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.OVER,
      400: VIDEOCONFERENCE_CONSTANTS.DISCONNECTED_STATUS.NOT_STARTED,
    };

    this.disconnected = errMap[err.status];
    this.headerSvc.setStateConection(false);

    if (errMap[err.status]) {
      this.roomSchedule = {
        delta: err?.error?.delta,
        status: errMap[err?.status],
        startsAt: err?.error?.startsAt,
      };
      console.log(
        'room handleRoomError this.publisher.off() (' +
          this.utilsService.getTodayWithHour() +
          ') :',
        err?.status === 404 || err?.status === 410
      );
      (err?.status === 404 || err?.status === 410) && this.publisher?.off();
      this.stateHandlerSrv.set('roomSchedule', this.roomSchedule, false);
      this.cdr.detectChanges();
    }

    /**
     * Code to try SSO Cookie:
     * If response is 401 and It has a sso Cookie (Also called SSo Token), the application call to validate this token
     */
    // if (err?.status === 401) {
    //   const attendantId = this.activatedRoute.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
    //   this.accessRoom(attendantId);
    // }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
